(function () {
  window.CustomPressBanner = window.CustomPressBanner || {};

  if (window.CustomPressBanner.loaded) return;

  window.CustomPressBanner.loaded = true;

  class CustomPressBannerElement extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.allowMultiple = this.dataset.allowMultiple === 'true';
      this.triggers = Array.from(this.querySelectorAll('[data-press-accordion-trigger]'));
      this.mediaPanels = Array.from(this.querySelectorAll('[data-press-media]'));

      if (!this.triggers.length) {
        this.initialized = false;
        return;
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      this.normalizeInitialState();
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.initialized = false;
    }

    normalizeInitialState() {
      const requestedOpen = this.triggers.filter(
        (trigger) => trigger.getAttribute('aria-expanded') === 'true'
      );
      const firstOpen = requestedOpen[0] || this.triggers[0];

      if (this.allowMultiple) {
        if (!requestedOpen.length) this.setExpanded(firstOpen, true);
      } else {
        this.triggers.forEach((trigger) => {
          this.setExpanded(trigger, trigger === firstOpen);
        });
      }

      this.showMedia(firstOpen.dataset.mediaTarget);
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-press-accordion-trigger]');

      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (!this.allowMultiple) {
        this.triggers.forEach((item) => {
          this.setExpanded(item, item === trigger);
        });
        this.showMedia(trigger.dataset.mediaTarget);
        return;
      }

      const openTriggers = this.triggers.filter(
        (item) => item.getAttribute('aria-expanded') === 'true'
      );

      if (isExpanded && openTriggers.length === 1) return;

      this.setExpanded(trigger, !isExpanded);

      if (!isExpanded) {
        this.showMedia(trigger.dataset.mediaTarget);
      } else {
        const nextOpen = this.triggers.find(
          (item) => item.getAttribute('aria-expanded') === 'true'
        );
        if (nextOpen) this.showMedia(nextOpen.dataset.mediaTarget);
      }
    }

    handleBlockSelect(event) {
      const eventBlock =
        event.target && typeof event.target.closest === 'function'
          ? event.target.closest('[data-press-accordion-item]')
          : null;
      const selectedBlock =
        eventBlock ||
        this.querySelector(`[data-block-id="${event.detail && event.detail.blockId}"]`);

      if (!selectedBlock || !this.contains(selectedBlock)) return;

      const trigger = selectedBlock.querySelector('[data-press-accordion-trigger]');
      if (!trigger) return;

      if (!this.allowMultiple) {
        this.triggers.forEach((item) => {
          this.setExpanded(item, item === trigger);
        });
      } else {
        this.setExpanded(trigger, true);
      }

      this.showMedia(trigger.dataset.mediaTarget);
    }

    setExpanded(trigger, expanded) {
      const panelId = trigger.getAttribute('aria-controls');
      const candidatePanel = panelId ? document.getElementById(panelId) : null;
      const panel = candidatePanel && this.contains(candidatePanel) ? candidatePanel : null;

      trigger.setAttribute('aria-expanded', String(expanded));
      if (panel) panel.hidden = !expanded;
    }

    showMedia(targetId) {
      // Class swap rather than `hidden`: the panels are stacked in one grid cell
      // and crossfaded in CSS, which keeps every image in the layout so they all
      // lazy-load up front instead of stalling on first reveal.
      this.mediaPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.pressMedia === targetId);
      });
    }
  }

  if (!customElements.get('custom-press-banner')) {
    customElements.define('custom-press-banner', CustomPressBannerElement);
  }
})();
